module.exports = __webpack_public_path__ + "img/banner-tc2.e3b5f0c2.jpg";